import { Box, Button, Popover, IconButton, ThemeProvider, createTheme } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import SettingsIcon from "@mui/icons-material/Settings";
import { useState, useRef } from "react";
import {getLocalStorageSettingValue, settings, userCanAccessSetting} from "settings";
import Options from "./options.component";

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: "#71b73a",
      dark: "#00682d",
      light: "#d0e2a9",
      contrastText: "#000",
    },
  },
});

export default function Settings({ currentUser, onChange, onSubmit, inputs }) {
  const [open, setOpen] = useState(false);
  const position = { right: 20, bottom: 20 };
  const anchorRef = useRef(null);

  function toggleDrawer() {
    setOpen(false);
  }

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ ...position, position: "fixed", zIndex: 10, transform: "translate(0,0)" }}>
        <IconButton
          ref={anchorRef}
          color="primary"
          onClick={() => setOpen(true)}
          size="large"
          title="Settings"
        >
          <SettingsIcon />
        </IconButton>
        <Popover 
          anchorEl={anchorRef.current} 
          open={open} 
          onClose={toggleDrawer} 
          anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
          transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Box sx={{ p: 2, minWidth: "20rem" }}>
            <form noValidate onSubmit={onSubmit}>
              <h2>Settings</h2>
              {settings.filter(s => userCanAccessSetting(currentUser, s)).map(setting => (
                <div key={setting.name}>
                  <Options
                    setting={setting}
                    value={
                      inputs[setting.name] ??
                      getLocalStorageSettingValue(setting.name) ??
                      setting.default
                    }
                    onChange={onChange}
                  />
                </div>
              ))}
              <Box sx={{ display: "flex", gap: 2 }}>
                <Button type="button" variant="outlined" onClick={() => setOpen(false)} fullWidth>
                  Cancel
                </Button>
                <Button type="submit" variant="contained" color="primary" startIcon={<CheckIcon />} fullWidth>
                  Apply
                </Button>
              </Box>
            </form>
          </Box>
        </Popover>
      </Box>
    </ThemeProvider>
  );
}
